import React, { useState, useEffect } from "react";
import { getModulesByPaginationQuery } from "./ModulesGqlQuery";
import {
  Typography,
  Input,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import { useQuery } from "@apollo/client";
import Spinner from "../common/Spinner";
import { connect } from "react-redux";
import DraggableTable from "../common/DraggableTable";
import CloseIcon from "@material-ui/icons/Close";
import UpdateModuleOrderDialog from "./UpdateModuleOrderDialog";
import AddModuleOrderDialog from "./AddModuleOrder";

const defaultPageSize = 20;
const defaultPage = 1;
const defaultSorted = [
  {
    id: "line_order",
    desc: false,
  },
];

const Modules = (props) => {
  const {
    data: modulesData,
    loading: modulesListLoading,
    refetch: modulesQueryRefetch
  } = useQuery(getModulesByPaginationQuery, {
    variables: {
      searchtext: null,
      sortedBy: defaultSorted,
      limit: defaultPageSize,
      offset: defaultPage,
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (
      modulesData &&
      modulesData.modulesByPaginationQuery &&
      modulesData.modulesByPaginationQuery
        .modules
    ) {
      setModulesList(
        modulesData.modulesByPaginationQuery
          .modules
      );
      setPages(
        modulesData.modulesByPaginationQuery
          .modules
        ? Math.ceil(
              modulesData
                .modulesByPaginationQuery.rowCount / defaultPageSize
            )
          : 1
      );
    } else {
      setModulesList([]);
    }
  }, [modulesData]);

  const [modulesList, setModulesList] = useState([]);
  const [pages, setPages] = useState(defaultPage);
  let [sortedArray, setSortedArray] = useState(defaultSorted);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [currentPage, setCurrentPage] = useState(0);
  let [searchtext, setSearchtext] = useState("");
    const [updateModuleOrderDialogOpen, setUpdateModuleOrderDialogOpen] = useState(false);
    const [addModuleOrderDialogOpen, setAddModuleOrderDialogOpen] = useState(false);

  
  const columns = [
    {
      HeaderText: "Module Name",
      Header: (props) => (
        <div className="draggable-header">
          <span className="reactTable-headerText">
            {"Module Name"}
            {(sortedArray &&
              sortedArray.filter((iName) => iName.id === "module_name").length >
                0) && <Icon className="sortableArrow">arrow_right_alt</Icon>}
          </span>
        </div>
      ),
      id: "module_name",
      HeaderText: "Module Name",
      Cell: (props) => {
        return <span className="flex items-center capitalize">
              {props.original.moduleName}
            </span>
      },
      sortable: true,
      multiSort: true,
    },
    {
      HeaderText: "Display Name",
      Header: (props) => (
        <div className="draggable-header">
          <span className="reactTable-headerText">
            {"Display Name"}
            {sortedArray &&
              sortedArray.filter((iName) => iName.id === "module_display_name")
                .length > 0 && (
                <Icon className="sortableArrow">arrow_right_alt</Icon>
              )}
          </span>
        </div>
      ),
      id: "module_display_name",
      Cell: (props) => {
        return <span className="flex items-center capitalize">
              {props.original.moduleDisplayName}
          </span>
        },
      sortable: true,
      multiSort: true,
    }
  ];

  const fetchData = (state, instance) => {
    
    let activePage =
      state.pageSize === pageSize && state.page ? state.page + 1 : 1;
    
    sortedArray = state.sorted;
    setSortedArray(state.sorted);

    setCurrentPage(activePage - 1);

    getData(state.pageSize, activePage);
  };

  const getData = async (pageSize, page) => {
    let newQueryVariables = {
      searchtext: searchtext || null,
      sortedBy: sortedArray,
      limit: pageSize,
      offset: page,
    };

    modulesQueryRefetch(newQueryVariables);
  };

  const redirectToModuleDetails = (Id) => {
    const { history } = props;
    history.push(`/admin/modules/modulesDetails/${Id}`);
  };

  var height = window.innerHeight - 155;

  return (
    <div className="reactTableWraper">
      {modulesListLoading && <Spinner />}
      <div className="header-Wraper justifyContentEnd">
          <Button
                                 variant="outlined"
                                 onClick={() => setAddModuleOrderDialogOpen(true)}
                                 className="primaryButton"
                                 style={{marginRight: 8}}
                               >
                                 <Typography style={{ fontSize: 14, color: "white" , }}>
                                   Add Module
                                 </Typography>
                               </Button>
           <Button
                                 variant="outlined"
                                 onClick={() => setUpdateModuleOrderDialogOpen(true)}
                                 className="primaryButton"
                                 style={{marginRight: 8}}
                               >
                                 <Typography style={{ fontSize: 14, color: "white" , }}>
                                   Update Module Order
                                 </Typography>
                               </Button>
        <div className="header-Wraper-right">
      
          <div className="formInputWraper">
            <Input
              placeholder={"Search"}
              className="flex flex-1 w-full"
              disableUnderline
              inputProps={{
                "aria-label": "Search",
                className: "inputStyle",
              }}
              value={searchtext}
              onChange={async (e) => {
                if (e.target.value) {
                  searchtext = e.target.value;
                  setSearchtext(e.target.value);
                } else {
                  await setSearchtext("");
                  searchtext = "";
                  getData(defaultPageSize, defaultPage);
                }
              }}
              onKeyPress={(e) => {
                if (e && e.key === "Enter") {
					setCurrentPage(0);
                  getData(defaultPageSize, defaultPage);
                }
              }}
            />
            <IconButton
              color="inherit"
              onClick={(ev) => {
                ev.stopPropagation();
                getData(defaultPageSize, defaultPage);
              }}
            >
              <Icon>search</Icon>
            </IconButton>
          </div>
        </div>
      </div>
      <DraggableTable
        manual // Forces table not to paginate or sort automatically, so we can handle it server-side
        pages={pages} // Display the total number of pages
        loading={modulesListLoading} // Display the loading overlay when we need it
        onFetchData={fetchData} // Request new data when things change
        data={modulesList}
        expanderDefaults={{ width: 0 }}
        columns={columns}
        resizable={true}
        noDataText={
          !modulesListLoading &&
          modulesList.length === 0 &&
          searchtext ? (
            <Typography>{"No results for " + searchtext.trim()}</Typography>
          ) : (
            "No record found"
          )
        }
        minRows={1}
        defaultSorted={sortedArray}
        pageSizeOptions={[20, 25, 50, 100]}
        defaultPageSize={pageSize}
        pageSize={pageSize}
        page={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
        }}
        onPageSizeChange={(sz) => {
          setCurrentPage(0);
          setPageSize(sz);
        }}
        multiSort={true}
        collapseOnDataChange={false}
        style={{
          maxHeight: height - 44,
          cursor: "pointer",
        }}
        getTrProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (ev) => {
              ev.stopPropagation();
              redirectToModuleDetails(rowInfo.original.id);
            },
          };
        }}
      />

   <Dialog
          fullWidth={true}
          scroll={"paper"}
          maxWidth="sm"
          classes={{
            paper: "popoverOverflow",
          }}
          disableBackdropClick
          open={updateModuleOrderDialogOpen}
          onClose={() => setUpdateModuleOrderDialogOpen(false)}
        
        >
          <DialogTitle
          // className="popoverOverflow"
            // className={dialogTitle}
            style={{
              padding: 5,
              backgroundColor: "#3F51B5",
              color: "#fff",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography style={{ marginLeft: 8, fontSize: 18 }}>
                Update Module Order
              </Typography>
              <IconButton onClick={() => setUpdateModuleOrderDialogOpen(false)}>
                <CloseIcon style={{ color: "white" }} color="fff" />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent 
          // classes={{
          //   root: "popoverOverflow",
          // }}                  
          >
            <UpdateModuleOrderDialog
              onSuccess={() => {
                modulesQueryRefetch()
              setUpdateModuleOrderDialogOpen(false)
              }}
              props={props}
           
              handleClose={() => setUpdateModuleOrderDialogOpen(false)}
            />
          </DialogContent>
        </Dialog>


 <Dialog
          fullWidth={true}
          scroll={"paper"}
          maxWidth="sm"
          classes={{
            paper: "popoverOverflow",
          }}
          disableBackdropClick
          open={addModuleOrderDialogOpen}
          onClose={() => setAddModuleOrderDialogOpen(false)}
        
        >
          <DialogTitle
          // className="popoverOverflow"
            // className={dialogTitle}
            style={{
              padding: 5,
              backgroundColor: "#3F51B5",
              color: "#fff",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography style={{ marginLeft: 8, fontSize: 18 }}>
                Add Module Order
              </Typography>
              <IconButton onClick={() => setAddModuleOrderDialogOpen(false)}>
                <CloseIcon style={{ color: "white" }} color="fff" />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent 
          // classes={{
          //   root: "popoverOverflow",
          // }}                  
          >
            <AddModuleOrderDialog
              onSuccess={() => {
                modulesQueryRefetch()
              setAddModuleOrderDialogOpen(false)
              }}
              props={props}
           
              handleClose={() => setAddModuleOrderDialogOpen(false)}
            />
          </DialogContent>
        </Dialog>

    </div>
  );
};

const mapStateToProps = ({}) => {
  return {};
};

export default connect(mapStateToProps)(Modules);
